export * from "../../original/js/components/upload";

// soon to be depricated.
import { Upload } from "../../original/js/components/upload";

export default Upload
